/* Draft storefront enforcement. Checkout validation must also be enabled before launch. */
(function () {
  'use strict';
  const rules = window.RdcChewLimits;
  if (!rules || window.rdcChewLimitsBooted) return;
  window.rdcChewLimitsBooted = true;
  let cartRows = [], ready = false, refreshPromise = null;
  const root = window.Shopify?.routes?.root || '/';
  const builders = () => [...document.querySelectorAll('foxsell-mix-match')].filter(b => b.config?.bundleId === rules.bundleId);
  const selected = builder => builder.getSelectedItems().flatMap(c => c.items.map(item => ({ variantId: item.id, quantity: item.quantity })));
  function show(message, builder) {
    const host = builder || document.querySelector('main') || document.body;
    let notice = host.querySelector('.rdc-chew-limit-notice');
    if (!notice) {
      notice = document.createElement('p');
      notice.className = 'rdc-chew-limit-notice';
      notice.setAttribute('role', 'alert');
      notice.setAttribute('tabindex', '-1');
      notice.style.cssText = 'grid-column:1/-1;align-self:start;justify-self:stretch;height:auto;min-height:0;margin:0 0 16px;padding:14px;background:#f7f5ee;border:2px solid #c37535;border-radius:6px;color:#1f2320;font-size:16px;line-height:1.4';
      host.prepend(notice);
    }
    notice.textContent = message;
    notice.hidden = !message;
    if (message) notice.focus({ preventScroll: true });
  }
  async function refresh() {
    if (refreshPromise) return refreshPromise;
    refreshPromise = (async () => {
      const response = await fetch(root + 'cart.js', { credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' } });
      if (!response.ok) throw new Error(rules.messages.unavailable);
      cartRows = rules.cartItems(await response.json());
      ready = true;
      return cartRows;
    })();
    try { return await refreshPromise; }
    catch (error) { ready = false; throw error; }
    finally { refreshPromise = null; }
  }
  rules.checkBuilderAddition = function (builder, item, quantity) {
    if (builder.config?.bundleId !== rules.bundleId) return true;
    if (!ready) { show(rules.messages.loading, builder); refresh().catch(e => show(e.message, builder)); return false; }
    const lines = [...selected(builder), { variantId: item.id, quantity }];
    const result = rules.check(lines, cartRows);
    show(result.message, builder);
    return result.ok;
  };
  function start() {
    refresh().catch(error => { if (builders().length) show(error.message, builders()[0]); });
    for (const builder of builders()) {
      builder.addEventListener('foxsell:bundle-updated', () => {
        const result = rules.check(selected(builder), cartRows);
        show(result.message, builder);
      });
      const form = builder.querySelector('form');
      if (!form) continue;
      let submitting = false, approved = false;
      form.addEventListener('submit', async event => {
        if (approved) { approved = false; return; }
        event.preventDefault(); event.stopImmediatePropagation();
        if (submitting) return;
        submitting = true;
        try {
          await refresh();
          const result = rules.check(selected(builder), cartRows, true);
          show(result.message, builder);
          if (!result.ok) return;
          approved = true;
          form.requestSubmit(event.submitter || undefined);
          setTimeout(() => refresh().catch(() => {}), 750);
        } catch (error) { show(error.message || rules.messages.unavailable, builder); }
        finally { submitting = false; }
      }, true);
    }
  }
  // Recheck the current cart before the theme checkout button forwards the buyer.
  // Accelerated checkouts and direct requests still require a Shopify validation function.
  const allowed = new WeakSet();
  let checkoutPending = false;
  document.addEventListener('click', async event => {
    const button = event.target.closest?.('[name="checkout"],a[href="/checkout"],a[href^="/checkout?"]');
    if (!button) return;
    const visibleBundleLine = document.querySelector('cart-drawer a[href*="/products/build-your-own-chew-box"], #main-cart-items a[href*="/products/build-your-own-chew-box"], form[action$="/cart"] a[href*="/products/build-your-own-chew-box"]');
    if (!cartRows.length && !visibleBundleLine) return;
    if (allowed.has(button)) { allowed.delete(button); return; }
    event.preventDefault(); event.stopImmediatePropagation();
    if (checkoutPending) return;
    checkoutPending = true;
    try {
      await refresh();
      const result = rules.check([], cartRows);
      show(result.message);
      if (result.ok) {
        if (window.RdcChewHolder?.verifyCheckout) await window.RdcChewHolder.verifyCheckout();
        allowed.add(button); button.click();
      }
    } catch (error) { show(error.message || rules.messages.unavailable); }
    finally { checkoutPending = false; }
  }, true);
  window.addEventListener('focus', () => refresh().catch(() => {}));
  document.addEventListener('visibilitychange', () => { if (!document.hidden) refresh().catch(() => {}); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
